import { Box, Theme } from '@mui/material';
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    position: 'relative',
    zIndex: theme.zIndex.appBar,
  },
}));

type ClassKey = 'root';

export type LayoutAppBarProps = {
  classes?: Partial<Record<ClassKey, string>>;
  background?: string;
};

type Props = React.PropsWithChildren<LayoutAppBarProps>;

const LayoutAppBar: React.FC<Props> = (props: Props) => {
  const classes = useStyles();

  const { background = 'white', children, classes: classesProp } = props;

  return (
    <Box
      className={classNames(classes.appBar, classesProp?.root)}
      color="black"
      style={{ background }}
    >
      {children}
    </Box>
  );
};

export default LayoutAppBar;
